import { render, staticRenderFns } from "./GuildListPage.vue?vue&type=template&id=07472656&scoped=true"
import script from "./GuildListPage.vue?vue&type=script&lang=js"
export * from "./GuildListPage.vue?vue&type=script&lang=js"
import style0 from "./GuildListPage.vue?vue&type=style&index=0&id=07472656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07472656",
  null
  
)

export default component.exports